export default __webpack_public_path__ + "static/media/up-arrow.e278ff9a.svg";